<script lang="ts" setup="">
import { THEME } from '@pkg/config/misc/theme';

const props = withDefaults(defineProps<{
  theme: THEME;
  indent?: 'left' | 'right' | 'both' | 'none';
  hasImage?: 'left' | 'right' | 'both' | 'none';
}>(), {
  indent: 'none',
  hasImage: 'none',
});

const classes = reactive({
  section: ['left', 'right', 'both'].includes(props.hasImage) ? 'items-center' : '',
  leftIndent: ['left', 'both'].includes(props.indent) ? 'indent--left' : '',
  rightIndent: ['right', 'both'].includes(props.indent) ? 'indent--right' : '',
});
</script>

<template>
  <PartialSection
    v-if="$slots.left || $slots.right"
    :theme="props.theme || THEME.DARK"
    class="c-layout-section"
  >
    <div class="c-layout-section--wrapper wrapper" :class="classes.section">
      <div v-if="$slots.left">
        <div :class="classes.leftIndent">
          <slot name="left" />
        </div>
      </div>
      <div v-if="$slots.right">
        <div :class="classes.rightIndent">
          <slot name="right" />
        </div>
      </div>
    </div>
  </PartialSection>
</template>

<style scoped>
.c-layout-section--wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--layout-section-gap, 1.5rem);

  @screen tablet-wide {
    flex-direction: row;
    gap: var(--layout-section-gap, 2rem);
  }

  > * {
    flex: 0 1 auto;
    width: 100%; /* [1] */
  }
}

.indent--left {
  @screen tablet-wide {
    margin-left: 6.375rem;
  }
}

.indent--right {
  @screen tablet-wide {
    margin-right: 6.375rem;
  }
}
</style>
